export default {
  leadData: [],
  leadTotalData: 0,
  sellOperationFiltersData: null,
  reserveOperationFiltersData: null,
}